import ShiftsHelpMdx from "../../help/shifts.mdx";

export function ShiftsHelpPage() {
  return <ShiftsHelpMdx />;
}
